import { render, staticRenderFns } from "./ConcurrentLabelDropdownItem.vue?vue&type=template&id=703c5792&scoped=true&"
import script from "./ConcurrentLabelDropdownItem.vue?vue&type=script&lang=js&"
export * from "./ConcurrentLabelDropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./ConcurrentLabelDropdownItem.vue?vue&type=style&index=0&id=703c5792&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703c5792",
  null
  
)

export default component.exports